module.exports = __webpack_public_path__ + "media/images/flags/32/Sudan-9da85c042b7ca11ccd35ff17d4e31dd2.png";